module.exports = __webpack_public_path__ + "assets/0db1791ed7411d879603b4b989623807.mp4";